//kpis
import { avgEngagementRateHistoryConfig } from '@/lib/analytics/charts/linkedin/averageEngagementRateHistory';
import { commentsHistoryConfig } from '@/lib/analytics/charts/linkedin/commentsHistory';
//charts
import { followersGrowthHistoryConfig } from '@/lib/analytics/charts/linkedin/followersGrowthHistory';
import { postLifeSpanConfig } from '@/lib/analytics/charts/linkedin/postLifeSpan';
import { reactionsHistoryConfig } from '@/lib/analytics/charts/linkedin/reactionsHistory';
import { avgEngagementRatePostConfig } from '@/lib/analytics/kpis/linkedin/avgEngagementRatePost';
import { followersEvolutionConfig } from '@/lib/analytics/kpis/linkedin/followerEvolution';
import { totalFollowersConfig } from '@/lib/analytics/kpis/linkedin/followers';
import { followersEvolutionPercentageConfig } from '@/lib/analytics/kpis/linkedin/followersEvolutionPercentage';
import { impressionsConfig } from '@/lib/analytics/kpis/linkedin/impressions';
import { totalClicksConfig } from '@/lib/analytics/kpis/linkedin/totalClicks';
import { totalCommentsReceivedConfig } from '@/lib/analytics/kpis/linkedin/totalCommentsReceived';
import { totalPostsConfig } from '@/lib/analytics/kpis/linkedin/totalPosts';
import { totalReachConfig } from '@/lib/analytics/kpis/linkedin/totalReach';
import { totalReactionsConfig } from '@/lib/analytics/kpis/linkedin/totalReactions';
import { totalSharesConfig } from '@/lib/analytics/kpis/linkedin/totalShares';
//widget
import { mostRecentPostsConfig } from '@/lib/analytics/widget/linkedin/mostRecentPostsConfig';

export const OverviewLinkedin = [
    totalFollowersConfig,
    followersEvolutionConfig,
    followersEvolutionPercentageConfig,
    totalPostsConfig,
    totalReachConfig,
    impressionsConfig,
    avgEngagementRatePostConfig,
    followersGrowthHistoryConfig,
    avgEngagementRateHistoryConfig,
    mostRecentPostsConfig,
    totalReactionsConfig,
    totalCommentsReceivedConfig,
    totalClicksConfig,
    totalSharesConfig,
    postLifeSpanConfig,
    reactionsHistoryConfig,
    commentsHistoryConfig
];

export const requestLinkedinParams = [
    // LinkedinAccountMetrics
    [
        'followers',
        'followers_evolution',
        'followers_evolution_percentage',
        'reach',
        'follower_growth_history'
    ],
    // LinkedinMedia
    [
        'posts',
        'impressions',
        'average_engagement_rate_per_post',
        'average_engagement_rate_history',
        'reactions',
        'comments',
        'clicks',
        'shares',
        'media_life_span',
        'reactions_history',
        'comments_history'
    ]
];

export const requestLinkedinOtherParameters = {
    media_life_span: {
        type: 'reactions',
        id_media: null
    }
};
